<ng-container>
	<form [formGroup]="invoiceForm" *ngIf="invoiceForm" (keydown.enter)="onEnterKeyDown($event)" class="no-overflow mt-3">
		<ng-template matStepLabel>Invoice Information</ng-template>
		<div class="container-fluid">
			<!-- Invoice Details Section -->
			<div class="row">
				<div class="col-12">
					<h4>Invoice Details</h4>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Reference</mat-label>
						<input matInput required formControlName="reference" placeholder="Enter invoice reference" (keyup)="onReferenceBlur()">
						<mat-error *ngIf="invoiceForm.get('reference')?.hasError('referenceUsed')">Invoice reference already used for this vendor</mat-error>
						<mat-error *ngIf="invoiceForm.get('reference')?.invalid && invoiceForm.get('reference')?.errors?.required && invoiceForm.get('reference')?.touched">Reference is required</mat-error>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Department</mat-label>
						<mat-select formControlName="tag">
							<mat-option [value]="null">— None —</mat-option>
							<mat-option *ngFor="let tag of glTags" [value]="tag">{{ tag.description }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Delivery Date</mat-label>
						<input matInput [matDatepicker]="invoiceDate" formControlName="invoiceDate" placeholder="Select delivery date">
						<mat-datepicker-toggle matSuffix [for]="invoiceDate"></mat-datepicker-toggle>
						<mat-datepicker #invoiceDate></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Exchange Rate</mat-label>
						<span matSuffix>%</span>
						<input matInput required formControlName="rate" placeholder="Enter exchange rate" (input)="onRateInput($event)">
					</mat-form-field>
				</div>
			</div>


			<!-- Payment Terms Section -->
			<div class="row mt-3">
				<div class="col-12">
					<h4>Payment Terms</h4>
				</div>
				<div class="col-md-4">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Due Date</mat-label>
						<input matInput [matDatepicker]="dueDate" formControlName="dueDate" placeholder="Select due date">
						<mat-datepicker-toggle matSuffix [for]="dueDate"></mat-datepicker-toggle>
						<mat-datepicker #dueDate></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-md-4">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Discount Date</mat-label>
						<input matInput [matDatepicker]="discountDate" formControlName="discountDate" placeholder="Select discount date">
						<mat-datepicker-toggle matSuffix [for]="discountDate"></mat-datepicker-toggle>
						<mat-datepicker #discountDate></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-md-4">
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Discount Amount</mat-label>
						<span matPrefix>$</span>
						<input matInput formControlName="discountAmount" placeholder="Enter discount amount" (input)="setDiscount($event)">
						<mat-error *ngIf="invoiceForm.get('discountAmount').invalid">Invalid Discount</mat-error>
					</mat-form-field>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6 row justify-content-around">
				<div class="d-flex align-items-center mb-2" *ngIf="config.env.package == 'tires'">
					<button mat-raised-button color="accent" (click)="openNoPoItemsModal()" class="mr-2">
						<mat-icon>inventory</mat-icon>
						NO PO Items
					</button>
				</div>
				<mat-form-field class="full-width d-flex" [ngClass]="{'w-75': config?.env?.package == 'tires', 'pl-rem3 w-100': config?.env?.package != 'tires'}" appearance="outline">
					<mat-label>GRN's</mat-label>
					<mat-chip-list #grnList aria-label="Selected Pos">
						<mat-chip *ngFor="let grn of selected_grnbatches" (removed)="remove(grn)">
							GRN#: {{ grn.grnbatch }}
							<a (click)="navigateToPO(grn.orderno); $event.stopPropagation()"
							   *ngIf="grn.orderno"
							   class="po-link"
							   matTooltip="Edit Purchase Order {{grn.orderno}}">
								PO#:{{grn.orderno}}
							</a>
							<span *ngIf="!grn.orderno">PO#:{{grn.orderno}}</span>
							<span *ngIf="grn.sales_orderno"> SO#:{{grn.sales_orderno}}</span>
							<button matChipRemove>
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip>
						<input type="text" matInput #grnInput placeholder="Select Purchase Order" [matChipInputFor]="grnList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" formControlName="grns" [matAutocomplete]="auto">
					</mat-chip-list>

					<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
						<mat-option *ngFor="let grn of filteredGrnBatches()" [value]="grn">
							GRN#: {{ grn.grnbatch }} PO#:{{grn.orderno}}<span *ngIf="grn.sales_orderno"> SO#:{{grn.sales_orderno}}</span>
						</mat-option>
					</mat-autocomplete>
					<mat-suffix class="grn-count-label">GRN COUNT
						<ng-container *ngIf="getting_supplier">
							<svg class="spinner" width="18px" height="18px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" color="white" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</ng-container>
						<ng-container *ngIf="!getting_supplier">{{filteredGrnBatches().length}}</ng-container>

					</mat-suffix>
				</mat-form-field>
			</div>

			<div class="col-md-6" [ngClass]="selected_grns.length >= 1 ? 'mt-3' : '' ">
				<app-gl-account-lookup (glselected)="addGl($event)" [reset]="resetGlLookup"></app-gl-account-lookup>
			</div>
			<div class="col-md-12">
				<div class="table invoice-table">
					<table class="table table-sm table-fixed" *ngIf="selected_grns.length || glcharges.length">
						<thead>
							<tr>
								<th>Item</th>
								<th>Desc</th>
								<th>PO#</th>
								<th matTooltip="Received qty / PO ordered qty">Recvd / Ord</th>
								<th class="text-center" matTooltip="Qty already invoiced on prior vendor invoices / qty received on this GRN line">Invcd / Recd</th>
								<th class="text-right">PO Price</th>
								<th class="text-center">Qty</th>
								<th class="text-right">Invoice Price</th>
								<th class="text-right" *ngIf="config?.env?.package == 'tires'">FET</th>
								<th class="text-right">Line Total</th>
								<th class="text-right"></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let grn of selected_grns">
							<tr>
								<td class="pt-4">
									{{ grn.itemcode }}
								</td>
								<td class="pt-4">
									{{ grn.itemdescription }}
									<br/>
									<button mat-stroked-button [ngClass]="grn?.showadditional ? 'grn-remove-note' : 'grn-additional-note'" (click)="showNoteField(grn)">
										<ng-container *ngIf="!grn?.showadditional">+ note</ng-container>
										<ng-container *ngIf="grn?.showadditional">- note</ng-container>
									</button>
								</td>
								<td class="pt-4">
									<a (click)="navigateToPO(grn.orderno)"
									   *ngIf="grn.orderno"
									   class="po-link"
									   matTooltip="Edit Purchase Order {{grn.orderno}}">
										{{ grn.orderno }}
									</a>
									<span *ngIf="!grn.orderno">-</span>
								</td>
								<td class="pt-4 text-center">
									<span class="vendor-qty-pill" [ngClass]="vendorRecvdOrdPillClass(grn)" matTooltip="Received / PO ordered">{{ grn.qtyrecd }} / {{ grn.quantityord }}</span>
								</td>
								<td class="pt-4 text-center">
									<span class="vendor-qty-pill" [ngClass]="vendorInvcdRecdPillClass(grn)" matTooltip="Already invoiced / received">{{ (+grn.quantityinv || 0) }} / {{ (+grn.qtyrecd || 0) }}</span>
								</td>
								<td class="pt-4 text-right">{{ (grn.poUnitPrice != null && grn.poUnitPrice !== '' ? grn.poUnitPrice : grn.unitprice) | currency}}</td>
								<td class="text-center">
									<mat-form-field appearance="outline" class="text-center">
										<mat-label>Invoice Qty.</mat-label>
										<input matInput required [(value)]="grn.toinvoice" (input)="setQty($event, grn)" appSelectOnFocus>
									</mat-form-field>
								</td>
								<td class="text-right align-top vendor-invoice-price-cell">
									<div class="vendor-price-field-shell"
										[ngClass]="{
											'vendor-price-field-shell--warn': invoicePriceDiffersFromPo(grn),
											'vendor-price-field-shell--ok': invoicePriceMatchesPo(grn)
										}"
										[matTooltip]="invoicePriceDiffersFromPo(grn) ? invoicePricePoDiffTooltip(grn) : invoicePriceMatchTooltip(grn)"
										[matTooltipDisabled]="!invoicePriceDiffersFromPo(grn) && !invoicePriceMatchesPo(grn)">
										<mat-form-field appearance="outline" class="vendor-price-mat-field text-left" subscriptSizing="dynamic">
											<span matPrefix>$</span>
											<mat-label>Invoice Price</mat-label>
											<input matInput required [(value)]="grn.unitprice" (input)="setPrice($event, grn)" moneyPipe appSelectOnFocus>
											<mat-hint *ngIf="invoicePriceMatchesPo(grn)" class="vendor-price-hint vendor-price-hint--ok">Matches PO</mat-hint>
											<mat-hint *ngIf="invoicePriceDiffersFromPo(grn)" class="vendor-price-hint vendor-price-hint--warn">Differs from PO</mat-hint>
										</mat-form-field>
									</div>
								</td>
								<td class="pt-4 text-right" *ngIf="config?.env?.package == 'tires'">
									{{ ((grn.fetcharge || 0) * (grn.toinvoice || 0)) | currency}}
								</td>
								<td class="pt-4 text-right">
									<b> {{ ((grn.unitprice || 0) * (grn.toinvoice || 0)) | currency}}</b>
								</td>
								<td class="pt-4 text-right">
									<button mat-flat-button (click)="removeLine(grn)">
										<i class="material-icons">remove</i>
									</button>
								</td>								
							</tr>
							<tr *ngIf="grn?.showadditional">
								<td [attr.colspan]="config?.env?.package == 'tires' ? 11 : 10" class="pt-4 text-center">
									<mat-form-field appearance="outline" class="text-left w-50">
										<mat-label>{{grn.itemcode}} note</mat-label>
										<input matInput [(value)]="grn.additionaldesc" (input)="setNote($event, grn)">
									</mat-form-field>
								</td>	
							</tr>
							</ng-container>
							<ng-container *ngFor="let gl of glcharges">
								<tr>
									<td class="pt-4">{{ gl.account }}</td>
									<td class="pt-4">{{ gl.name }}</td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td class="text-right">
										<mat-form-field appearance="outline" class="text-left">
											<span matPrefix>$</span>
											<mat-label>Price</mat-label>
											<input matInput required [(value)]="gl.value" (input)="setGlPrice($event, gl)" moneyPipe appSelectOnFocus>
										</mat-form-field>
									</td>
									<td class="pt-4"></td>
									<td class="pt-4" *ngIf="config?.env?.package == 'tires'"></td>
									<td class="pt-4 text-right">
										<b> {{ gl.value * gl.quantity | currency}}</b>
									</td>
									<td class="pt-4 text-right">
										<button mat-flat-button (click)="removeGl(gl)">
											<i class="material-icons">remove</i>
										</button>
									</td>
								</tr>
								<tr>
									<td [attr.colspan]="config?.env?.package == 'tires' ? 11 : 10" class="pt-4 text-center">
										<mat-form-field appearance="outline" class="text-left w-50">
											<mat-label>{{gl.account}} note</mat-label>
											<input matInput [(value)]="gl.description" (input)="setGlNote($event, gl)">
										</mat-form-field>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<div class="row">
					<div class="col-12 text-right" *ngIf="selected_grns.length || glcharges.length">
						<h5 class="mr-4">Sub-Total: {{ invoiceTotal | currency }}</h5>
						<ng-container>
							<div class="ml-auto text-right" *ngFor="let tax of applicableTaxes">
								<mat-form-field appearance="fill" class="ml-auto col-2 text-right">
									<span matPrefix>$</span>
									<mat-label>{{ tax.description }}</mat-label>
									<input matInput required value="{{tax.taxamount | number:'1.2-2'}}" (input)="setTaxValue($event, tax)" appSelectOnFocus>
								</mat-form-field>
							</div>
						</ng-container>
					</div>
					<div class="col-12 text-right">

						<h5 class="mr-4">Tax: {{ taxTotal | currency }}</h5>
						<h5 class="mr-4" *ngIf="config?.env?.package == 'tires' && fetTotal > 0">FET Total: {{ fetTotal | currency }}</h5>
						<h5 class="mr-4">Discount: {{ discount | currency }}</h5>
						<h5 class="mr-4">Total: {{ totalTotal | currency }}</h5>
						<ng-container *ngIf="sending; else submitButton">
							<button mat-raised-button class="loading-button" disabled>
								<svg class="cool-spinner" viewBox="0 0 50 50">
									<circle class="circle" cx="25" cy="25" r="20"></circle>
								</svg>

							</button>
						</ng-container>

						<ng-template #submitButton>
							<button mat-stroked-button type="button" color="primary" class="mr-2" (click)="openGlPreview()">
								Preview GL
							</button>
							<button mat-raised-button [color]="invoiceForm.valid ? 'primary' : 'accent'" [disabled]="invoiceForm.invalid" (click)="onSubmit()">
								Create Invoice
							</button>
						</ng-template>

					</div>
				</div>
			</div>
		</div>
		<div class="row mt-3 align-items-end">
			<div class="col-md-4 vendor-attachments-wrap">
				<h5 class="mb-2">Attachments</h5>
				<ngx-dropzone (change)="onAttachmentSelect($event)" class="dropzone-attachments">
					<ngx-dropzone-label>Drop or click (PDF, images, Word, Excel)</ngx-dropzone-label>
					<ngx-dropzone-preview *ngFor="let f of attachmentFiles" [removable]="true" (removed)="onAttachmentRemove(f)">
						<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
					</ngx-dropzone-preview>
				</ngx-dropzone>
			</div>
		</div>
	</form>
	<div class="text-center bold" *ngIf="!selected_grns.length  && !glcharges.length">
		Add Purchase Orders And/Or GL Charges
	</div>
</ng-container>